import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/saga-blue/theme.css'; 
import 'primereact/resources/primereact.min.css'; 
import LeadService from '../../services/LeadService';
import AuthService from '../../services/AuthService';
import { MdAddCircleOutline } from 'react-icons/md';
import ToastService from '../../services/ToastService';
import { property } from 'lodash';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}
  
function AddLead() {
  const queryParam = useQuery();
  const navigate = useNavigate();
  const toast = useRef(null);
  const [leads, setLeads] = useState([]);
  const toastService = new ToastService(toast); 
  const [LeadId] = useState(null);
  const [UserId] = useState(() => AuthService.resolveScopedUserId(queryParam.get("id")));
  const clientIdFromLocation = location.state?.clientId;
  const ClientId = AuthService.getLoggedInClientId();

  const [form, setForm] = useState({
    firstname: "",
    lastname: "", 
    email: "",
    contactnumber: "",
    startDate:"",
    endDate:"",
    address:"",
    source:"",
    property:"",
    sourceTypeId:"",
    userId:UserId,
    clientId: ClientId
  });

  const [formError, setFormError] = useState({
    firstname: "",
    lastname: "",
    email: "",
    contactnumber: "",
    startDate:"",
    endDate:"",
    address:"",
    source:"",
    property:"",
    sourceTypeId:"",
    userId:UserId,
    clientId:"",
  });


  const SourceType = {
    FACEBOOK: { sourceTypeId: 1, sourceTypeName: 'Facebook' },
    INSTAGRAM: { sourceTypeId: 2, sourceTypeName: 'Instagram' },
    REFERENCE: { sourceTypeId: 1, sourceTypeName: 'Reference' },
  };
  

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setFormError((prevErrors) => ({ ...prevErrors, [name]: '' })); 
  };
  

  async function getAll() {
    try {
      const uid = UserId ?? AuthService.getLoggedInUserId();
      if (uid == null || uid === "") {
        setLeads([]);
        return;
      }
      const leadsData = await LeadService.getAllLeads(uid);
      setLeads(leadsData);
    } catch (error) {
      console.log('Error fetching leads: ', error);
    }
  }

  useEffect(() => {
    getAll();
  }, [LeadId]);

  function onLeadSubmit() {

    const errors = {
      firstname: form.firstname.trim().length === 0,
      email: form.email.trim().length === 0,
      contactnumber: form.contactnumber.trim().length === 0,
      startDate: form.startDate.trim().length === 0,
      endDate: form.endDate.trim().length === 0,
      address: form.address.trim().length === 0,
      source: form.source.trim().length === 0,
      property: form.property.trim().length === 0,
      sourceTypeId: form.sourceTypeId.trim().length === 0,
    };
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form.email.trim().length > 0 && !emailRegex.test(form.email)) {
      errors.email = 'Please enter a valid email address';
    }
  
    const errorMessages = Object.keys(errors).reduce((acc, key) => {
      if (errors[key] === true) {
        return {
          ...acc,
          [key]: `Please enter ${key}!!!`,
        };
      } else if (typeof errors[key] === 'string') {
        return {
          ...acc,
          [key]: errors[key],
        };
      }
      return acc;
    }, {});
  

    setFormError(errorMessages);
  
    if (Object.keys(errorMessages).length === 0) {
     saveLead();
    }
  }
  

  async function saveLead() {   
      const requestData = {
        firstname: form.firstname,
        lastname: form.lastname,
        email: form.email,
        contactnumber: form.contactnumber,
        startDate:form.startDate,
        endDate:form.endDate,
        sourceTypeId:form.sourceTypeId,
        address:form.address,
        source:form.source,
        property:form.property,
        UserId: UserId,
        clientId: ClientId
      };
      
      try {
        await LeadService.createLead(requestData);
        toastService.showSuccess("Success", "Lead saved successfully!");
        resetForm();
        navigate("/leads");
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const validationErrors = error.response.data.errors;
          toastService.showError("Validation Error", "Please fill out all required fields");
        } else {
          toastService.showError("Error", "Error saving lead");
        }
      }
    }

  function resetForm() {
    setForm({
      firstname: "",
      lastname: "",
      email: "",
      contactnumber: "",
      startDate:"",
      endDate:"",
      address:"",
      sourceTypeId: "",
      userId:UserId,
      clientId: "",
    });
    setFormError({
        firstname: "",
        lastname: "",
        email: "",
        contactnumber: "",
        startDate:"",
        endDate:"",
        address:"", 
        sourceTypeId: "",
        userId:UserId,
        clientId: "",
    });
  }

  const lbl = {
    display: 'block', fontSize: '12px', fontWeight: '600',
    color: '#8392ab', marginBottom: '6px',
    textTransform: 'uppercase', letterSpacing: '0.05em',
  };
  const inp = (err) => ({
    width: '100%', padding: '10px 14px',
    border: `1.5px solid ${err ? '#f5365c' : '#e9ecef'}`,
    borderRadius: '10px', fontSize: '14px', color: '#344767',
    background: '#fff', outline: 'none', boxSizing: 'border-box',
    transition: 'border-color 0.2s',
  });
  const errMsg = {
    fontSize: '11px', color: '#f5365c', marginTop: '4px',
    display: 'flex', alignItems: 'center', gap: '4px',
  };

  const SecHead = ({ color, icon, title }) => (
    <div style={{ paddingBottom: '10px', borderBottom: '1.5px solid #f0f2f5', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
      <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', color, fontSize: '13px' }}>
        <i className={`fas ${icon}`} />
      </div>
      <p style={{ fontSize: '13px', fontWeight: '700', color: '#344767', textTransform: 'uppercase', letterSpacing: '0.06em', margin: 0 }}>{title}</p>
    </div>
  );

  /* source-type icon map */
  const sourceIcons = { 1: 'fa-facebook', 2: 'fa-instagram', 3: 'fa-users' };
  const sourceColors = { 1: '#1877f2', 2: '#e1306c', 3: '#2dce89' };
  const selectedSourceColor = sourceColors[form.sourceTypeId] || '#8392ab';

  return (
    <div style={{ padding: '24px', minHeight: '100vh', background: '#f4f6fb' }}>
      <Toast ref={toast} />
      <style>{`
        .al-input:focus  { border-color: #344767 !important; box-shadow: 0 0 0 3px rgba(52,71,103,0.1) !important; }
        .al-select:focus { border-color: #344767 !important; box-shadow: 0 0 0 3px rgba(52,71,103,0.1) !important; outline: none; }
        .al-submit:hover { opacity: 0.88; transform: translateY(-1px); }
        .al-ghost:hover  { background: #f0f2f5 !important; }
        .al-src-chip { transition: all 0.2s; cursor: pointer; border: 2px solid transparent; }
        .al-src-chip:hover { transform: translateY(-2px); }
      `}</style>

      {/* Page Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '12px',
            background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: '20px', boxShadow: '0 4px 12px rgba(52,71,103,0.3)',
          }}>
            <i className="fas fa-user-plus" />
          </div>
          <div>
            <p style={{ fontSize: '22px', fontWeight: '700', color: '#344767', margin: 0, lineHeight: 1.2 }}>Add New Lead</p>
            <p style={{ fontSize: '13px', color: '#8392ab', margin: 0, marginTop: '2px' }}>
              Fill in the details below to create a new lead
            </p>
          </div>
        </div>
        <button
          type="button"
          className="al-ghost"
          onClick={() => navigate('/leads')}
          style={{
            background: '#fff', border: '1.5px solid #e9ecef', borderRadius: '10px',
            padding: '9px 20px', fontSize: '13px', fontWeight: '600', color: '#525f7f',
            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '7px', transition: 'all 0.2s',
          }}
        >
          <i className="fas fa-arrow-left" />Back to Leads
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: '20px', boxShadow: '0 4px 24px rgba(52,71,103,0.08)', overflow: 'hidden' }}>

        {/* Gradient strip */}
        <div style={{
          background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
          padding: '20px 28px', display: 'flex', alignItems: 'center', gap: '10px',
        }}>
          <i className="fas fa-address-card" style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px' }} />
          <span style={{ color: '#fff', fontWeight: '600', fontSize: '15px' }}>Lead Information</span>
        </div>

        <div style={{ padding: '32px 28px' }}>

          {/* Section 1 – Personal Details */}
          <div style={{ marginBottom: '28px' }}>
            <SecHead color="#5e72e4" icon="fa-user" title="Personal Details" />
            <div className="row g-3">
              {[
                { label: 'First Name', name: 'firstname', type: 'text', required: true },
                { label: 'Last Name', name: 'lastname', type: 'text' },
                { label: 'Email Address', name: 'email', type: 'email', required: true },
              ].map(({ label, name, type }) => (
                <div className="col-md-4" key={name}>
                  <label style={lbl} htmlFor={name}>{label}</label>
                  <input
                    type={type} id={name} name={name}
                    className="al-input"
                    style={inp(!!formError[name])}
                    placeholder={label}
                    value={form[name] || ''}
                    onChange={changeHandler}
                  />
                  {formError[name] && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError[name]}</p>}
                </div>
              ))}
            </div>
          </div>

          {/* Section 2 – Contact & Location */}
          <div style={{ marginBottom: '28px' }}>
            <SecHead color="#fb6340" icon="fa-phone-alt" title="Contact & Location" />
            <div className="row g-3">
              <div className="col-md-4">
                <label style={lbl} htmlFor="contactnumber">Contact Number</label>
                <input
                  type="number" id="contactnumber" name="contactnumber"
                  className="al-input"
                  style={inp(!!formError.contactnumber)}
                  placeholder="+91 XXXXX XXXXX"
                  value={form.contactnumber || ''}
                  onChange={(e) => { if (String(e.target.value).length <= 13) changeHandler(e); }}
                  maxLength="13"
                />
                {formError.contactnumber && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError.contactnumber}</p>}
              </div>
              <div className="col-md-4">
                <label style={lbl} htmlFor="address">Address</label>
                <input
                  type="text" id="address" name="address"
                  className="al-input"
                  style={inp(!!formError.address)}
                  placeholder="Full Address"
                  value={form.address || ''}
                  onChange={changeHandler}
                />
                {formError.address && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError.address}</p>}
              </div>
              <div className="col-md-4">
                <label style={lbl} htmlFor="property">Property Interest</label>
                <input
                  type="text" id="property" name="property"
                  className="al-input"
                  style={inp(!!formError.property)}
                  placeholder="e.g. 2BHK, Plot in Sector 10"
                  value={form.property || ''}
                  onChange={changeHandler}
                />
                {formError.property && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError.property}</p>}
              </div>
            </div>
          </div>

          {/* Section 3 – Dates */}
          <div style={{ marginBottom: '28px' }}>
            <SecHead color="#2dce89" icon="fa-calendar-alt" title="Lead Timeline" />
            <div className="row g-3">
              <div className="col-md-4">
                <label style={lbl} htmlFor="startDate">Start Date</label>
                <input
                  type="datetime-local" id="startDate" name="startDate"
                  className="al-input"
                  style={inp(!!formError.startDate)}
                  value={form.startDate || ''}
                  onChange={changeHandler}
                />
                {formError.startDate && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError.startDate}</p>}
              </div>
              <div className="col-md-4">
                <label style={lbl} htmlFor="endDate">End Date</label>
                <input
                  type="datetime-local" id="endDate" name="endDate"
                  className="al-input"
                  style={inp(!!formError.endDate)}
                  value={form.endDate || ''}
                  onChange={changeHandler}
                />
                {formError.endDate && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError.endDate}</p>}
              </div>
            </div>
          </div>

          {/* Section 4 – Source */}
          <div>
            <SecHead color="#11cdef" icon="fa-link" title="Lead Source" />
            <div className="row g-3">
              {/* Visual source-type chips */}
              <div className="col-12" style={{ marginBottom: '8px' }}>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {Object.values(SourceType).filter((v, i, a) => a.findIndex(t => t.sourceTypeId === v.sourceTypeId) === i).map(({ sourceTypeId, sourceTypeName }) => {
                    const ic = sourceIcons[sourceTypeId] || 'fa-globe';
                    const col = sourceColors[sourceTypeId] || '#8392ab';
                    const selected = String(form.sourceTypeId) === String(sourceTypeId);
                    return (
                      <button
                        key={sourceTypeId}
                        type="button"
                        className="al-src-chip"
                        onClick={() => { setForm(f => ({ ...f, sourceTypeId: String(sourceTypeId) })); setFormError(e => ({ ...e, sourceTypeId: '' })); }}
                        style={{
                          display: 'flex', alignItems: 'center', gap: '8px',
                          padding: '9px 18px', borderRadius: '10px',
                          background: selected ? col + '18' : '#f8f9fe',
                          border: `2px solid ${selected ? col : '#e9ecef'}`,
                          color: selected ? col : '#8392ab',
                          fontWeight: selected ? '700' : '500',
                          fontSize: '13px',
                        }}
                      >
                        <i className={`fab ${ic}`} style={{ fontSize: '15px' }} />
                        {sourceTypeName}
                        {selected && <i className="fas fa-check-circle" style={{ fontSize: '12px', marginLeft: '4px' }} />}
                      </button>
                    );
                  })}
                </div>
                {formError.sourceTypeId && <p style={{ ...errMsg, marginTop: '8px' }}><i className="fas fa-exclamation-circle" />{formError.sourceTypeId}</p>}
              </div>

              <div className="col-md-4">
                <label style={lbl} htmlFor="source">Source Detail</label>
                <input
                  type="text" id="source" name="source"
                  className="al-input"
                  style={inp(!!formError.source)}
                  placeholder="e.g. Facebook Ad, Referral by John"
                  value={form.source || ''}
                  onChange={changeHandler}
                />
                {formError.source && <p style={errMsg}><i className="fas fa-exclamation-circle" />{formError.source}</p>}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '20px 28px', background: '#f8f9fe',
          borderTop: '1.5px solid #f0f2f5',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px',
        }}>
          <span style={{ fontSize: '13px', color: '#8392ab', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-info-circle" style={{ color: '#5e72e4' }} />
            Fields marked with * are required
          </span>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="button"
              className="al-ghost"
              onClick={resetForm}
              style={{
                background: 'transparent', border: '1.5px solid #e9ecef',
                borderRadius: '10px', padding: '10px 24px',
                fontSize: '14px', fontWeight: '600', color: '#8392ab',
                cursor: 'pointer', transition: 'all 0.2s',
              }}
            >
              <i className="fas fa-undo" style={{ marginRight: '7px' }} />Reset
            </button>
            <button
              type="button"
              className="al-submit"
              onClick={onLeadSubmit}
              style={{
                background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
                border: 'none', borderRadius: '10px', padding: '10px 32px',
                fontSize: '14px', fontWeight: '700', color: '#fff',
                cursor: 'pointer', boxShadow: '0 4px 15px rgba(52,71,103,0.3)',
                display: 'flex', alignItems: 'center', gap: '8px', transition: 'all 0.2s',
              }}
            >
              <i className="fas fa-user-plus" />Add Lead
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddLead;
